<template>
  <div>
    <v-data-table
      :headers="tableHeaders"
      :items="tableItems"
      :loading="loading"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      item-key="id"
      dense
      class="elevation-1 margin-top-1"
    >
      <template v-slot:[`item.documentDate`]="{ item }">
        <span>{{ formatDate(item.documentDate) }}</span>
      </template>
      <template v-slot:[`item.subject`]="{ item }">
        <span>{{ decodeSubject(item.subject) }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on" @click="showPreview(item)">
              mdi-eye-outline
            </v-icon>
          </template>
          <span>Vorschau anzeigen</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-dialog
      v-model="showPreviewDialog"
      :max-width="previewLoading ? '250px' : '75vw'"
    >
      <v-card
        class="custom-scrollbar"
        :style="{ height: previewLoading ? 'unset' : '95vh' }"
        :loading="previewLoading"
      >
        <v-toolbar dark color="secondary">
          <v-toolbar-title>E-Mail Vorschau</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="hidePreview()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <email-preview
          v-if="showPreviewDialog"
          :customerId="customerId"
          :documentId="previewItem.id"
          @loading-started="emailLoadingStarted"
          @loading-complete="emailLoadingCompleted"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DisplayContainer from '@/components/elements/DisplayContainer.vue';
import NotificationObject from '@/main/NotificationObject.js';
import TimeUtility from '@/util/TimeUtility.js';
import rfc2047 from 'rfc2047';

import { HTTP } from '@/main/httpClient.js';

export default {
  name: 'DisplayEmailArchive',
  components: {
    DisplayContainer,
    EmailPreview: () => import('./EmailPreview.vue')
  },
  props: {
    customerId: { type: Number, required: true }
  },
  data: () => ({
    loading: false,
    tableHeaders: [
      { text: 'Datum', value: 'documentDate' },
      { text: 'Betreff', value: 'subject' },
      { text: 'Username', value: 'username' },
      { text: 'Aktionen', value: 'actions' }
    ],
    tableItems: [],
    sortBy: 'documentDate',
    sortDesc: true,
    showPreviewDialog: false,
    previewItem: null,
    previewLoading: false
  }),
  mounted: function () {
    this.loadData(this.customerId);
  },
  methods: {
    showMessage: function (type, description) {
      this.$store.commit(
        'addNotification',
        new NotificationObject(type, description)
      );
    },
    formatDate(date) {
      if (!date) return date;
      return TimeUtility.formatLocalDate(date);
    },
    loadData(customerId) {
      this.loading = true;
      this.documentData = undefined;
      this.documentTableData = [];
      HTTP.get(`/email-archive/customer/${customerId}`)
        .then(({ data, status }) => {
          if (status !== 200) {
            return this.showMessage(
              'warning',
              'Das E-Mail Archiv konnte nicht geladen werden'
            );
          }

          this.tableItems = data;
        })
        .catch((e) => {
          console.error(e);
          return this.showMessage(
            'warning',
            'Das E-Mail Archiv konnte nicht geladen werden'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showPreview: function (email) {
      this.previewItem = email;
      this.showPreviewDialog = true;
    },
    hidePreview: function () {
      this.showPreviewDialog = false;
      this.previewItem = null;
    },
    decodeSubject(subject) {
      return rfc2047.decode(subject);
    },
    emailLoadingStarted() {
      this.previewLoading = true;
    },
    emailLoadingCompleted() {
      this.previewLoading = false;
    }
  }
};
</script>

<style></style>
